interface Record<T> {
  [key: string]: T
}

function isString(x: any): x is string {
  return typeof x === 'string'
}

function orderCriteriaString(a: string, b: string): number {
  const fieldA = a ? a.toUpperCase() : a
  const fieldB = b ? b.toUpperCase() : b

  if (fieldA < fieldB) {
    return -1
  }
  if (fieldA > fieldB) {
    return 1
  }

  return 0
}

function orderCriteriaNumber(a: number, b: number): number {
  return b - a
}

// function sort<T>(field: string, a: Record<T>, b: Record<T>): Record<T> {
function sort(field: string, a: Record<number>, b: Record<number>): number
function sort(field: string, a: Record<string>, b: Record<string>): number
function sort(field: string, a: Record<any>, b: Record<any>): number {
  if (isString(a[field]) && isString(b[field])) {
    return orderCriteriaString(a[field], b[field])
  }

  return orderCriteriaNumber(a[field], b[field])
}

function reverse<T>(list: T[]): T[] {
  return [...list].reverse()
}

function order(
  list: Array<any>,
  field: string,
  orientation = 'asc',
): Array<any> {
  if (orientation === 'asc') {
    return [...list].sort((a, b) => sort(field, a, b))
  }

  return reverse([...list].sort((a, b) => sort(field, a, b)))
}

export { order }
